import { Link } from 'react-router-dom';
import type { Actor } from '@/mocks/actors';

interface ActorCardProps {
  actor: Actor;
  movieCount?: number;
}

export default function ActorCard({ actor, movieCount = 0 }: ActorCardProps) {
  return (
    <Link
      to={`/actors/detail/${actor.id}`}
      className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-300"
    >
      <div className="h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-background-200">
        <img
          src={actor.avatar}
          alt={`${actor.name}照片`}
          title={`${actor.name}演员资料`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {actor.name}
          </h3>
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
            {actor.roleTag}
          </span>
        </div>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {actor.summary}
        </p>
        <p className="mt-1.5 text-xs text-foreground-500">
          <i className="ri-film-line mr-1"></i>
          共 {movieCount} 部作品 · {actor.region}
        </p>
      </div>
    </Link>
  );
}